export enum LogLevel {
    log = 'log',
    info = 'info',
    warn = 'warn',
    error = 'error',
}
